module.exports = __webpack_public_path__ + "static/img/img-cp4-1.e712e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp4-1.png
// module id = rWa9
// module chunks = 0